import script from "./device-status.vue?vue&type=script&setup=true&lang=js"
export * from "./device-status.vue?vue&type=script&setup=true&lang=js"

import "./device-status.vue?vue&type=style&index=0&id=2c476fd6&scoped=true&lang=css"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c476fd6"]])

export default __exports__